import React, { useEffect, useState, useMemo, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import HeaderTop from "../../Layout/HeaderTop";
import SideBar from "../../Layout/Sidebar/SideBar";
import { Link } from "react-router-dom";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Swal from "sweetalert2";
import { Navigate, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Layout, Space } from "antd";
import FooterBottom from "../../Layout/FooterBottom";
import SideMenu from "../../Layout/SideMenu";

import {
  Container,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
} from "reactstrap";
import TableContainer from "../Util/TableContainer";
//import 'bootstrap/dist/css/bootstrap.min.css';
import { SelectColumnFilter } from "../Util/filters";
import axios from "../../api/axios";

const EmployeeSalary = () => {
  const { Header, Footer, Sider, Content } = Layout;
  const headerStyle: React.CSSProperties = {
    textAlign: "center",
    height: 64,
    paddingInline: 50,
    lineHeight: "64px",
    backgroundColor: "#ffff",
  };

  const contentStyle: React.CSSProperties = {
    float: "left",
  };

  const siderStyle: React.CSSProperties = {
    backgroundColor: "#ffff",
  };

  const footerStyle: React.CSSProperties = {
    backgroundColor: "#fff",
  };
  const [data, setData] = useState([]);
  const GetSalaryMasterListFromCompanyIdandUnitIdURL =
    "/GetSalaryMasterListFromCompanyIdandUnitId";
  const tableRef = useRef(null);
  const navigate = useNavigate();
  

  useEffect(() => {
    const doFetch = async () => {
      // const response = await fetch('https://randomuser.me/api/?results=100');
      const response = await axios.get(
        GetSalaryMasterListFromCompanyIdandUnitIdURL +
          "?CompanyId=" +
          localStorage.getItem("companyId") +
          "&UnitId=" +
          localStorage.getItem("unitId")
      );
      console.log(response.data);
      // response.data.shift();
      setData(response.data);
    };
    doFetch();
  }, []);

  const EditData = (id) => {
    //let { id} = data;
    // localStorage.setItem('EditUserId', id);
    //alert(id);
    navigate("/SalaryMaster", { state: { id } });
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "rowNum",
        //disableSortBy: true,
        //filterable: false,
        disableFilters: true,
        // Filter: SelectColumnFilter,
        //filter: 'equals',
      },
      {
        Header: "Card No",
        accessor: "employeeCardNo",
        //disableSortBy: false,
        // Filter: SelectColumnFilter,
        // filter: 'equals',
      },
      {
        Header: "Basic",
        accessor: "basic",
        disableFilters: true,
      },
      {
        Header: "Rate",
        accessor: "rate",
        disableFilters: true,
      },
      {
        Header: "Rate Type",
        accessor: "rateType",
        Filter: SelectColumnFilter,
      },
      {
        Header: "PFRate",
        accessor: "pfRate",
        disableFilters: true,
      },
      {
        Header: "EffectiveMonth",
        accessor: "effectiveMonth",
        disableFilters: true,
      },

      // {
      //   Header: 'Email',
      //   accessor: 'email',
      // },
      {
        Header: "Status",
        Filter: SelectColumnFilter,
        accessor: "status",
      },
      {
        Header: "Action", //() => null,
        id: "salaryId", // 'id' is required
        accessor: "salaryId",
        disableFilters: true,
        Cell: ({ row }) => (
          <span {...row}>
            <button
              style={{ width: "40%", height: "40px", color: "green" }}
              onClick={(e) => {
                EditData(row.cells[8].value);
              }}
              className="btn"
            >
              <i className="fa fa-pencil-square-o"></i>
            </button>
            {/* &nbsp;
           <button style={{width:'40%', height:'40px' ,color:'red' }} onClick={(e) => {InActiveData(row.cells[4].value)}} className="btn" ><i className='fa fa-close'></i></button> */}
          </span>
        ),
      },
    ],
    []
  );

  return (
    <>
      <Layout>
        <Header style={headerStyle}>
          <HeaderTop></HeaderTop>
        </Header>
        <Layout hasSider>
          <Sider style={siderStyle}>
            <SideMenu></SideMenu>
          </Sider>
          <Content style={contentStyle}>
            <div className="col-lg-12" style={{ padding: "20px 50px" }}>
              <div className="row">
                <div className="col-lg-10">
                  {" "}
                  <h4>
                    <b>Employee Salary List</b>
                  </h4>
                </div>
                <div className="col-lg-2">
                  {/* <button onClick={(e) => {EditData(0)}}  className="btn btn-success">Add New (+)</button> */}
                  <button
                    onClick={(e) => {
                      EditData(0);
                    }}
                    className="btn btn-primary"
                  >
                    Add New (+)
                  </button>
                </div>
              </div>
              <div style={{ paddingTop: "20px" }}>
                <TableContainer
                  table
                  table-striped
                  bordered
                  table-sm
                  columns={columns}
                  data={data}
                  tableRef={tableRef}
                />
              </div>
            </div>
          </Content>
        </Layout>
        <Footer style={footerStyle}>
          <FooterBottom />
        </Footer>
      </Layout>
    </>
  );
};

export default EmployeeSalary;
